import { sharedApi } from '@/shared/api/shared.api';
import { useCheckImagesSizes } from '@/shared/lib/hooks/useCheckImageSizes';
import { useAppDispatch } from '@/shared/model';
import { setNotification } from '@/shared/model/appSlice';
import DropInput from '@/shared/ui/DropInput/DropInput';
import type { FileWithPreview } from '@/shared/ui/Input/Input';

interface Props {
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

export const InputBannerImage = ({ value, onChange, error }: Props) => {
  const checkImages = useCheckImagesSizes();
  const dispatch = useAppDispatch();

  const handleImageUpload = async ([files]: FileWithPreview[][]) => {
    if (!files || !files.length) return;

    const err = await checkImages({
      files,
      minWidth: 1372,
      minHeight: 424,
    });

    if (err) {
      dispatch(
        setNotification({
          variant: 'error',
          value: 'Ошибка при загрузке (маленький размер)',
        })
      );
      return;
    }

    const formData = new FormData();
    formData.append('file', files[0]);
    const response = await sharedApi.createFile(formData);
    onChange(response.data.file);
  };

  return (
    <DropInput
      title='Креатив'
      htmlFor='image'
      value={value || ''}
      files={value ? [value] : ([] as unknown as File[])}
      setFiles={handleImageUpload}
      onDelete={() => onChange('')}
      withIcon
      sizes='(1372x424 px)'
      error={error}
    />
  );
};
